import {Link, useParams, useSearchParams} from "react-router-dom";
import React, {useEffect} from "react";
import Box from "@mui/material/Box";
import {Grid, Typography} from "@mui/material";
import {useSelector} from "react-redux";
import Button from "@mui/material/Button";
import Chip from '@mui/material/Chip';
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Cancel';
import {sets} from "../data/sets";
import useMediaQuery from '@mui/material/useMediaQuery';
import {useTheme} from '@mui/material/styles';
import {API_SPEC} from "../spec/apiSpec";
import {useApi} from "../hooks/api-hook";
import MtgPrints from "./MtgPrints";
import {galleryLink} from "../utils/linkMaker";
import {useKeycloak} from "@react-keycloak/web";
import AddCardToCollection from "./collection/AddCardToCollection";
import {useNavigate} from "react-router";
import MtgOffers from "./MtgOffers";
import {cardDetails, isInPaper} from "../utils/cardUtils";

export default function MtgCard() {

    const {keycloak, initialized: kinitialized} = useKeycloak();
    const [searchParams, setSearchParams] = useSearchParams();
    const {isLoading, data, api, initialized} = useApi();
    const theme = useTheme();
    const {set, no} = useParams();
    const {items: cards} = useSelector((state) => state.cardReducer)
    const lang = searchParams.get("l") || 'en';
    const {items: prints} = useSelector((state) => state.printReducer)
    const card = cards.find(c => c.collector_number == no && c.set == set && c.lang === lang)
        || prints.find(c => c.collector_number === no && c.set === set && c.lang === lang)
        || cards.find(c => c.collector_number == no && c.set == set)
    const [open, setOpen] = React.useState(false);
    const navigate = useNavigate()
    const {searchPrompt, searchPromptAuto} = useSelector((state) => state.controlsReducer)


    const matches = useMediaQuery(theme.breakpoints.down('md'));
    useEffect(() => {
        if (card) {
            const print_spec = API_SPEC.SEARCH_PRINTS(card.oracle_id)
            api(print_spec);
        }
    }, [card?.oracle_id, initialized]);

    /*    useEffect(() => {
            if (cards?.length !== 1) {
                navigate(`/search?q=${searchPrompt}`);
            }
        }, [cards, searchPrompt]);*/

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    if (!card) return

    if (matches) {
        return (<>

        <Box sx={{marginTop: 4}}>
                <Box sx={{marginTop: 4, marginBottom: 4, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>      
                    <Typography variant="h4">{card.printed_name ? card.printed_name : card.name} {card.mana_cost}</Typography>
                <Box>
                    
            {kinitialized && keycloak.authenticated
                && isInPaper(card.games)
                && <>
                    <Button sx={{margin: 1}} color="success" variant={"contained"} onClick={handleClickOpen}>Sell This Card</Button>
                    <AddCardToCollection open={open} handleClose={() => handleClose()}
                                         name={card.name} id={card.id}/>
                </>
            }
            {kinitialized && keycloak.authenticated
                && isInPaper(card.games)
                && <>
                    <Button sx={{margin: 1}} color="warning" variant={"contained"} onClick={handleClickOpen}>Add to My Want List</Button>
                    <AddCardToCollection open={open} handleClose={() => handleClose()}
                                         name={card.name} id={card.id}/>
                </>
            }
                </Box>
            </Box>
        </Box>
            <Box height={16}/>
            
            <Grid container spacing={{xs: 1, sm: 2, md: 2}} columns={{xs: 1, sm: 2, md: 2}}>
                <Grid item xs={1} sm={1} md={1}>
                    <Box
                        component="img"
                        sx={{
                            maxWidth: {xs: "100%", md: "100%"}, borderRadius: 4,
                        }}
                        alt={card.name}
                        src={galleryLink(card.object, card.id)}
                    />
                </Grid>
                <Grid item xs={1} sm={1} md={1}>
                    <Grid container spacing={{xs: 1, sm: 1, md: 2}} columns={{xs: 1, sm: 1, md: 1}}>
                        <Grid item xs={1} sm={1} md={1}>
                            <Typography
                                variant="h6">{card.printed_type_line ? card.printed_type_line : card.printed_type_line}</Typography><br/>
                            <Typography>{cardDetails(card)}</Typography><br/>
                            <Typography>{card.flavor_text}</Typography><br/>
                            <Typography>Illustrated by {card.artist}</Typography><br/>
                            <Typography variant="h6">Legality</Typography><br/>
                            {/* <Stack display={"inline"}> */}
                            {Object.keys(card.legalities)
                                .map(k => (<Chip
                                    sx={{width: 140, margin: 0.2}}
                                    variant="outlined"
                                    icon={card.legalities[k] ? <CheckIcon/> : <CancelIcon/>}
                                    color={card.legalities[k] ? 'success' : 'error'}
                                    label={k}
                                />))}
                            {/* </Stack> */}
                        </Grid>
                        <Grid item md={1} sx={{marginTop: 2, width: '100%'}}>

                            <Typography variant="h6">
                                <Button sx={{width: '100%'}} component={Link} to={`/${card.set}`}>
                                    <Box
                                        component="img"
                                        sx={{maxHeight: 24, marginRight: 2,
                                        }}
                                        alt={card.name}
                                        src={sets.find(s => s.code === card.set).icon_svg_uri}
                                    />
                                    {card.set_name} ({card.set})
                                </Button>
                            </Typography>
                            <Typography>{card.collector_number} • {card.rarity}
                            </Typography>

                        </Grid>
                        <Grid item xs={1} sm={1} md={1}>
                            <Box>
                                <MtgPrints prints={prints}/>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Box height={24}/>
            <MtgOffers card={card}/>

        </>);
    } else return (<>
            <Box sx={{marginTop: 4}}>
                <Box sx={{marginTop: 4, marginBottom: 4, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>      
                    <Typography variant="h4">{card.printed_name ? card.printed_name : card.name} {card.mana_cost}</Typography>
                <Box>
                    
            {kinitialized && keycloak.authenticated
                && isInPaper(card.games)
                && <>
                    <Button sx={{margin: 1}} color="success" variant={"contained"} onClick={handleClickOpen}>Sell This Card</Button>
                    <AddCardToCollection open={open} handleClose={() => handleClose()}
                                         name={card.name} id={card.id}/>
                </>
            }
            {kinitialized && keycloak.authenticated
                && isInPaper(card.games)
                && <>
                    <Button sx={{margin: 1}} color="warning" variant={"contained"} onClick={handleClickOpen}>Add to My Want List</Button>
                    <AddCardToCollection open={open} handleClose={() => handleClose()}
                                         name={card.name} id={card.id}/>
                </>
            }
                </Box>
            </Box>
        </Box>
        <Grid container spacing={{md: 4}} columns={{md: 4, lg: 4, xl: 4}}>
            <Grid item xs={1} sm={1} md={1}>
                <Box
                    component="img"
                    sx={{
                        maxWidth: {md: "100%"}, borderRadius: 5,
                    }}
                    alt={card.name}
                    src={galleryLink(card.object, card.id)}
                />
                {!card.card_back_id && <Box
                    component="img"
                    sx={{
                        maxWidth: {md: "100%"}, borderRadius: 5,
                    }}
                    alt={card.name}
                    src={galleryLink(card.object, card.id, 'back')}
                />}

        <Box sx={{marginTop: 2}}>
        </Box>
            </Grid>
            <Grid item md={3}>
                <Grid container spacing={{md: 1}} columns={{md: 3, lg: 3, xl: 3}}>
                    <Grid item md={2}>
                        <Typography
                            variant="h6">{card.printed_type_line ? card.printed_type_line : card.type_line}</Typography><br/>
                        <Typography>{cardDetails(card)}</Typography><br/>
                        <Typography>{card.flavor_text}</Typography><br/>
                        <Typography>Illustrated by {card.artist}</Typography><br/>
                        <Typography variant="h6">Legality</Typography>
                        {/* <Stack direction="row" spacing={1}> */}
                        {Object.keys(card.legalities)
                            .map(k => (<Chip

                                sx={{
                                    width: 160, margin: 0.2, '& .MuiChip-label': {
                                        textAlign: "left", width: "100%"
                                    }
                                }}
                                variant="outlined"
                                icon={card.legalities[k] ? <CheckIcon/> : <CancelIcon/>}
                                color={card.legalities[k] ? 'success' : 'error'}
                                label={k}
                            />))}
                        {/* </Stack> */}
                    </Grid>
                    <Grid item md={1}>

                        <Typography variant="h6">
                            <Button display="" component={Link} to={`/${card.set}`}>
                                <Box
                                    component="img"
                                    sx={{
                                        maxHeight: 24, marginRight: 2,
                                    }}
                                    alt={card.set.name}
                                    src={sets.find(s => s.code === card.set)?.icon_svg_uri}
                                />
                                {card.set_name} ({card.set})
                            </Button>
                        </Typography>
                        <Typography>{card.collector_number} • {card.rarity}
                        </Typography>

                        <Grid container spacing={{md: 1}} columns={{md: 1, lg: 1, xl: 1}}>
                            <Grid item xs={1} sm={1} md={1}>
                                <MtgPrints prints={prints}/>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
        <Box height={24}/>
        <MtgOffers cardId={card.id}/>

    </>);

}

